import React from 'react';
import { localTime } from 'src/components/Timesheet/timesheetFormat';

export interface ShiftLabelProps {
  shiftName?: string | null;
  startAt: string;
  endAt: string;
  timezone: string;
  /** Shown in place of an absent `shiftName`; omit to render just the time range. */
  fallbackName?: string;
}

/**
 * "name · start–end" in the restaurant's own timezone — the piece shared by the kiosk's matched
 * shift, `EntryScheduleLabel` and `LinkShiftModal`'s candidates. Each caller keeps its own wrapper
 * (Tag / Button / plain text) and any siblings (a late tag, a date prefix).
 */
const ShiftLabel = ({ shiftName, startAt, endAt, timezone, fallbackName }: ShiftLabelProps) => {
  const name = shiftName || fallbackName;
  return (
    <>
      {name && (
        <>
          <span>{name}</span>
          <span aria-hidden> · </span>
        </>
      )}
      <span>{localTime(startAt, timezone)}</span>
      <span>–</span>
      <span>{localTime(endAt, timezone)}</span>
    </>
  );
};

export default ShiftLabel;
